//转换函数--13个
export const TranslateFunc = [
  {
    "key": "ToStringX",
    "name": "转字符串",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换为字符串\n【返回值类型】：字符串(String)\n【示例】：转字符串(123)【返回值】："123"`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDateTime",
    "name": "转日期时间",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成日期时间\n【返回值类型】：日期时间(OffsetDateTime)\n【示例】：转日期时间("2019-01-30T10:00:00+08:00")【返回值】: 2019-01-30T10:00+08:00`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToBoolean",
    "name": "转布尔值",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成等效的布尔值\n【返回值类型】：布尔值(Boolean)\n【示例】：转布尔值("True")【返回值】：true`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDecimal",
    "name": "转数值"
  },
  {
    "key": "ToBigDecimal",
    "name": "转数值",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成十进制数值\n【返回值类型】：十进制数值(BigDecimal)\n【示例】：转数值("40.23")【返回值】：40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToCustomBigDecimal",
    "name": "转自定义精度数值",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      },
      {
        "key": "number",
        "name": "小数位数",
        "type": "int"
      }
    ],
    "description": `【功能】：将转换值转换成指定精度的十进制数值\n【返回值类型】：十进制数值(BigDecimal)\n【示例】：转自定义精度数值("40.2,2")【返回值】：40.20`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToDouble",
    "name": "转双精度浮点数",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成双精度浮点数\n【返回值类型】：双精度浮点数(Double)\n【示例】：转双精度浮点数("40.23")【返回值】：40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToSingle",
    "name": "转单精度浮点数"
  },
  {
    "key": "ToFloat",
    "name": "转单精度浮点数",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成单精度浮点数\n【返回值类型】：单精度浮点数(Float)\n【示例】：转单精度浮点数("40.23")【返回值】：40.23`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToByte",
    "name": "转8位无符号整数",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成8位无符号整数\n【返回值类型】：8位无符号整数(Byte)\n【示例】：转8位无符号整数("10")【返回值】：10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToInt16",
    "name": "转16位有符号整数",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成16位有符号整数\n【返回值类型】：16位有符号整数(Int16)\n【示例】：转16位有符号整数("10")【返回值】：10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToInt32",
    "name": "转32位有符号整数",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成32位有符号整数\n【返回值类型】：32位有符号整数(Int32)\n【示例】：转32位有符号整数("10")【返回值】：10`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ToChineseMoney",
    "name": "转中文大写金额",
    "params": [
      {
        "key": "obj",
        "name": "转换值",
        "type": "object"
      }
    ],
    "description": `【功能】：将转换值转换成中文大写金额\n【返回值类型】：字符串(String)\n【示例】：转中文大写金额(40.23)【返回值】："肆拾元零贰角叁分"`,
    "type": "Translate",
    "keyFront": "DefaultFunction",
    "className": ""
  },
]